module.exports = __webpack_public_path__ + "img/dashboard-card.9192e10c.png";